var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid rounded border",attrs:{"height":_vm.primaryPhotoSize,"width":_vm.primaryPhotoSize,"src":_vm.standardMap.primaryPhoto.search}})])
}
var staticRenderFns = []

export { render, staticRenderFns }